import { createAsyncThunk } from '@reduxjs/toolkit';
import { customerSettingsService } from '../../services';

const salesforceAuthorize = createAsyncThunk(
  'campaigns/salesforceAuthorize',
  async (payload, thunkAPI) => {
      try {
          const response = await customerSettingsService.salesforceAuthorize(payload.companyId);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const salesforceoceAuthorize = createAsyncThunk(
  'campaigns/salesforceoceAuthorize',
  async (payload, thunkAPI) => {
      try {
          const response = await customerSettingsService.salesforceoceAuthorize(payload.companyId);
          return response.data;
      } catch (error) {
          return thunkAPI.rejectWithValue(error.message);
      }
  }
);

const markToTestAuth = createAsyncThunk(
    'campaigns/markToTestAuth',
    async (payload, thunkAPI) => {
        try {
            const response = await customerSettingsService.testAuth(payload.companyId, payload.data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
  );

  const saveMarkToTestAuth = createAsyncThunk(
    'campaigns/saveMarkToTestAuth',
    async (payload, thunkAPI) => {
        try {
            const response = await customerSettingsService.testAuth(payload.companyId, payload.data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
  );

export {
    salesforceAuthorize,
    salesforceoceAuthorize,
    markToTestAuth,
    saveMarkToTestAuth
}